import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Organization } from 'src/app/models/organization';
import { OrganizationsService } from 'src/app/services/organizations.service';
import { UsersService } from 'src/app/services/users.service';
import { TranslateModule } from '@ngx-translate/core';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';

import { ActivatedRoute, NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { MatNavList, MatListItem, MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';

@Component({
    selector: 'app-nav-menu',
    templateUrl: './nav-menu.component.html',
    styleUrls: ['./nav-menu.component.scss'],
    imports: [MatNavList, MatListModule, MatSidenavModule, MatListItem, RouterLink, RouterLinkActive, MatIcon, MatDivider, TranslateModule],
})
export class NavMenuComponent implements OnInit, OnDestroy {
    @Input() isExpanded: boolean = true;
    // showSettingsSubmenu: boolean = false;
    isShowing = false;
    // showSubSubMenu: boolean = false;
    // showPropertiesTranslates: boolean = false;
    // showRightsTranslates: boolean = false;
    // rightPropertiesTranslates = 'GUM-Properties-Translate';
    // rightRightsTranslates = 'GUM-Rights-Translate';

    currentUrl: string;

    currentOrganization: Organization;

    currentOrganizationChange: Subscription;

    constructor(
        private usersService: UsersService,
        private organizationsService: OrganizationsService,
        private router: Router,
        private route: ActivatedRoute
    ) {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.currentUrl = router.url;
            }
        });
    }

    ngOnInit() {
        this.currentOrganizationChange = this.organizationsService.currentOrganizationChange$.subscribe((o) => {
            this.currentOrganization = o;
        });

        // // Récupère les informations de l'utilisateur connecté
        // this.usersService.getSessionCurrentUser().subscribe(user => {

        //   if (user.rights.find(right => right.name === this.rightPropertiesTranslates)) {
        //     this.showPropertiesTranslates = true;
        //   }

        //   if (user.rights.find(right => right.name === this.rightRightsTranslates)) {
        //     this.showRightsTranslates = true;
        //   }
        // });
    }

    ngOnDestroy() {
        this.currentOrganizationChange.unsubscribe();
    }

    mouseenter() {
        if (!this.isExpanded) {
            this.isShowing = true;
        }
    }

    mouseleave() {
        if (!this.isExpanded) {
            this.isShowing = false;
        }
    }
}
